/**
 * Seats icon: modern chair line-art.
 * Uses the provided chair icon image.
 */
export default function SeatsIcon({ size = 20, style = {} }) {
  return (
    <img
      src="/icons/seats-icon.png"
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0, objectFit: 'contain', imageRendering: '-webkit-optimize-contrast', ...style }}
    />
  );
}
